

// import React, { useEffect, useState } from "react";
// import { Download } from "lucide-react";
// import { generateBalanceSheetPDF } from "../lib/pdf";
// import { Api } from "../Api/Api";

// const BalanceSheet = () => {
//   const [data, setData] = useState({
//     totalInvestment: 0,
//     interestGenerated: 0,
//     totalExpenses: 0,
//     netProfit: 0,
//     weeklyInterestPotential: 0,
//   });

//   const [filter, setFilter] = useState("all");
//   const [dateRange, setDateRange] = useState({ start: "", end: "" });

//   useEffect(() => {
//     loadBalanceSheet();
//   }, [filter, dateRange]);

//   const getCompletedWeeks = (givenDate) => {
//     const start = new Date(givenDate);
//     const today = new Date();
//     start.setHours(0, 0, 0, 0);
//     today.setHours(0, 0, 0, 0);
//     const diffDays = Math.floor((today - start) / 86400000);
//     return Math.floor(diffDays / 7);
//   };

//   const loadBalanceSheet = async () => {
//     try {
//       const [cRes, pRes, eRes] = await Promise.all([
//         fetch(`${Api}customers/list.php`),
//         fetch(`${Api}payments/list.php`),
//         fetch(`${Api}expenses/list.php`),
//       ]);

//       let customers = (await cRes.json()).customers || [];
//       let expenses = (await eRes.json()).expenses || [];

//       // --- DATE FILTERING ---
//       if (filter !== "all") {
//         const now = new Date();
//         let startDate;
//         if (filter === "weekly") startDate = new Date(now.setDate(now.getDate() - 7));
//         else if (filter === "monthly") startDate = new Date(now.setMonth(now.getMonth() - 1));
//         else if (filter === "custom") startDate = new Date(dateRange.start);

//         if (startDate) {
//           expenses = expenses.filter(e => new Date(e.date) >= startDate);
//         }
//       }

//       let totalInvestment = 0;
//       let interestGenerated = 0;
//       let weeklyInterestPotential = 0;

//       customers.forEach((c) => {
//         totalInvestment += Number(c.investment_amount || 0);
//         interestGenerated += Number(c.weekly_interest_amount || 0) * getCompletedWeeks(c.given_date);
//         if (c.status === "Active") {
//           weeklyInterestPotential += Number(c.weekly_interest_amount || 0);
//         }
//       });

//       const totalExpenses = expenses.reduce((sum, e) => sum + Number(e.amount || 0), 0);
//       const netProfit = interestGenerated - totalExpenses;

//       setData({
//         totalInvestment,
//         interestGenerated,
//         totalExpenses,
//         netProfit,
//         weeklyInterestPotential
//       });
//     } catch (err) {
//       console.error("Balance Sheet Error:", err);
//     }
//   };

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen space-y-6">
//       {/* FILTER HEADER */}
//       <div className="flex flex-wrap items-center justify-between gap-4 bg-white p-4 rounded-xl shadow-sm border">
//         <div>
//           <h1 className="text-2xl font-bold text-gray-800">Balance Sheet</h1>
//           <div className="flex gap-2 text-sm text-gray-500 uppercase tracking-widest font-semibold">
//             <span>Assets</span> <span className="text-gray-300">|</span> <span>Equity</span>
//           </div>
//         </div>

//         <div className="flex items-center gap-3">
//           <select 
//             className="border rounded-lg px-3 py-2 text-sm"
//             value={filter}
//             onChange={(e) => setFilter(e.target.value)}
//           >
//             <option value="all">All Time</option>
//             <option value="weekly">This Week</option>
//             <option value="monthly">This Month</option>
//             <option value="custom">Custom Range</option>
//           </select>

//           {filter === "custom" && (
//             <input 
//               type="date" 
//               className="border rounded-lg px-2 py-1 text-sm"
//               onChange={(e) => setDateRange({...dateRange, start: e.target.value})}
//             />
//           )}

//           <button
//             onClick={() => generateBalanceSheetPDF(data).save("Balance_Sheet.pdf")}
//             className="flex items-center gap-2 bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition"
//           >
//             <Download size={18} /> PDF
//           </button>
//         </div>
//       </div>

//       {/* BALANCE SHEET BOX */}
//       <div className="grid grid-cols-1 md:grid-cols-2 border-2 border-gray-200 rounded-2xl overflow-hidden shadow-2xl">
        
//         {/* LEFT SIDE: ASSETS */}
//         <div className="bg-white p-8">
//           <h2 className="text-sm font-black text-blue-600 uppercase tracking-tighter mb-6 border-b pb-2">Debit - Assets</h2>
//           <div className="space-y-6">
//             <BalanceRow label="Total Principal Investment" value={data.totalInvestment} />
//             <BalanceRow label="Weekly Interest Target (Active)" value={data.weeklyInterestPotential} />
            
//             <div className="mt-24 pt-6 border-t-4 border-double border-black">
//               <div className="flex justify-between items-center">
//                 <span className="text-xl font-black uppercase">Total Assets</span>
//                 <span className="text-2xl font-black text-blue-700">
//                   ₹{(data.totalInvestment + data.weeklyInterestPotential).toLocaleString()}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* RIGHT SIDE: EQUITY & PROFIT */}
//         <div className="bg-gray-50 p-8 border-l">
//           <h2 className="text-sm font-black text-green-600 uppercase tracking-tighter mb-6 border-b pb-2">Credit - Equity</h2>
//           <div className="space-y-6">
//             <BalanceRow label="Gross Interest Revenue" value={data.interestGenerated} green />
//             <BalanceRow label="Total Operating Expenses" value={-data.totalExpenses} red />
            
//             <div className="bg-white p-4 rounded-xl border-2 border-dashed border-green-200">
//                <BalanceRow label="Net Profit (Final)" value={data.netProfit} bold green />
//             </div>

//             <div className="mt-20 pt-6 border-t-4 border-double border-black">
//               <div className="flex justify-between items-center">
//                 <span className="text-xl font-black uppercase">Total Equity</span>
//                 <span className="text-2xl font-black text-green-700">
//                   ₹{data.netProfit.toLocaleString()}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const BalanceRow = ({ label, value, bold, red, green }) => (
//   <div className={`flex justify-between items-center ${bold ? "font-black" : "font-medium"}`}>
//     <span className="text-gray-600">{label}</span>
//     <span className={`${red ? "text-red-600" : green ? "text-green-600" : "text-gray-900"}`}>
//       ₹{Number(value).toLocaleString(undefined, { minimumFractionDigits: 2 })}
//     </span>
//   </div>
// );

// export default BalanceSheet;



import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { generateBalanceSheetPDF } from "../lib/pdf";
import { Api } from "../Api/Api";

const BalanceSheet = () => {
  const [data, setData] = useState({
    totalInvestment: 0,
    interestGenerated: 0, // Actual Payments Received
    totalExpenses: 0,
    netProfit: 0,
    weeklyInterestPotential: 0,
  });

  const [filter, setFilter] = useState("all");
  const [dateRange, setDateRange] = useState({ 
    start: new Date().toISOString().split("T")[0], 
    end: new Date().toISOString().split("T")[0] 
  });

  useEffect(() => {
    loadBalanceSheet();
  }, [filter, dateRange]);

  const loadBalanceSheet = async () => {
    try {
      // FETCH ALL DATA (Matching Dashboard)
      const [custRes, payRes, expRes] = await Promise.all([
        fetch(`${Api}customers/list.php`),
        fetch(`${Api}payments/list.php`),
        fetch(`${Api}expenses/list.php`),
      ]);

      const customers = (await custRes.json()).customers || [];
      const allPayments = (await payRes.json()).payments || [];
      const allExpenses = (await expRes.json()).expenses || [];

      // --- SETUP FILTER BOUNDARIES ---
      let filterStart = null;
      let filterEnd = new Date();
      filterEnd.setHours(23, 59, 59, 999);

      if (filter === "weekly") {
        const now = new Date();
        filterStart = new Date(now.setDate(now.getDate() - now.getDay()));
        filterStart.setHours(0, 0, 0, 0);
      } else if (filter === "monthly") {
        const now = new Date();
        filterStart = new Date(now.getFullYear(), now.getMonth(), 1);
        filterEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
      } else if (filter === "custom") {
        filterStart = new Date(dateRange.start);
        filterStart.setHours(0, 0, 0, 0);
        filterEnd = new Date(dateRange.end);
        filterEnd.setHours(23, 59, 59, 999);
      }

      // --- 1. FILTER EXPENSES ---
      const filteredExpenses = allExpenses.filter(e => {
        const d = new Date(e.expense_date);
        if (filter === "all") return true;
        return d >= filterStart && d <= filterEnd;
      });

      // --- 2. FILTER PAYMENTS (This ensures Balance Sheet matches Dashboard) ---
      const filteredPayments = allPayments.filter(p => {
        const d = new Date(p.payment_date || p.created_at); // Use your payment date field
        if (filter === "all") return true;
        return d >= filterStart && d <= filterEnd;
      });

      // --- 3. CALCULATIONS ---
      let totalInvestment = 0;
      let weeklyInterestPotential = 0;

    

      customers.forEach((c) => {
  if (c.status === "Active") {
    totalInvestment += Number(c.investment_amount || 0);
    weeklyInterestPotential += Number(c.weekly_interest_amount || 0);
  }
});


      // Revenue logic (Sum of actual payments in range)
      const interestGenerated = filteredPayments.reduce(
        (sum, p) => sum + Number(p.paid_amount || 0), 
        0
      );

      const totalExpenses = filteredExpenses.reduce(
        (sum, e) => sum + Number(e.amount || 0), 
        0
      );

      const netProfit = interestGenerated - totalExpenses;

      setData({
        totalInvestment,
        interestGenerated,
        totalExpenses,
        netProfit,
        weeklyInterestPotential
      });
    } catch (err) {
      console.error("Balance Sheet Error:", err);
    }
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen space-y-6">
      {/* FILTER HEADER */}
      {/* <div className="flex flex-wrap items-center justify-between gap-4 bg-white p-4 rounded-xl shadow-sm border">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Balance Sheet</h1>
          <p className="text-[10px] text-blue-600 font-black uppercase tracking-[0.2em]">Accounting Grade Report</p>
        </div>

        <div className="flex items-center gap-3">
          <select 
            className="border rounded-lg px-3 py-2 text-sm font-bold bg-gray-50 outline-none"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value="all">All Time</option>
            <option value="weekly">This Week</option>
            <option value="monthly">This Month</option>
            <option value="custom">Custom Range</option>
          </select>

          {filter === "custom" && (
            <div className="flex items-center gap-2 animate-in slide-in-from-right-2">
              <input 
                type="date" 
                className="border rounded-lg px-2 py-1 text-sm font-medium"
                value={dateRange.start}
                onChange={(e) => setDateRange({...dateRange, start: e.target.value})}
              />
              <span className="text-gray-400 font-bold">to</span>
              <input 
                type="date" 
                className="border rounded-lg px-2 py-1 text-sm font-medium"
                value={dateRange.end}
                onChange={(e) => setDateRange({...dateRange, end: e.target.value})}
              />
            </div>
          )}

          <button
            onClick={() => generateBalanceSheetPDF(data).save("Balance_Sheet.pdf")}
            className="flex items-center gap-2 bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition shadow-sm"
          >
            <Download size={18} /> PDF
          </button>
        </div>
      </div> */}

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 bg-white p-5 rounded-xl shadow-sm border">
  {/* Title Section */}
  <div className="w-full md:w-auto">
    <h1 className="text-2xl font-bold text-gray-800">Balance Sheet</h1>
    <p className="text-[10px] text-blue-600 font-black uppercase tracking-[0.2em]">
      Accounting Grade Report
    </p>
  </div>

  {/* Actions Section */}
  <div className="flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-3 w-full md:w-auto">
    {/* Dropdown - Full width on mobile */}
    <select 
      className="w-full sm:w-auto border rounded-lg px-3 py-2 text-sm font-bold bg-gray-50 outline-none focus:ring-2 focus:ring-blue-500"
      value={filter}
      onChange={(e) => setFilter(e.target.value)}
    >
      <option value="all">All Time</option>
      <option value="weekly">This Week</option>
      <option value="monthly">This Month</option>
      <option value="custom">Custom Range</option>
    </select>

    {/* Custom Date Inputs - Stacks on mobile */}
    {filter === "custom" && (
      <div className="flex flex-col xs:flex-row items-center gap-2 w-full sm:w-auto animate-in fade-in slide-in-from-top-1 duration-300">
        <input 
          type="date" 
          className="w-full xs:w-auto border rounded-lg px-2 py-1.5 text-sm font-medium focus:border-blue-500 outline-none"
          value={dateRange.start}
          onChange={(e) => setDateRange({...dateRange, start: e.target.value})}
        />
        <span className="text-gray-400 font-bold text-xs uppercase">to</span>
        <input 
          type="date" 
          className="w-full xs:w-auto border rounded-lg px-2 py-1.5 text-sm font-medium focus:border-blue-500 outline-none"
          value={dateRange.end}
          onChange={(e) => setDateRange({...dateRange, end: e.target.value})}
        />
      </div>
    )}

    {/* PDF Button - Full width on mobile */}
    <button
      onClick={() => generateBalanceSheetPDF(data).save("Balance_Sheet.pdf")}
      className="w-full sm:w-auto flex justify-center items-center gap-2 bg-black text-white px-5 py-2.5 rounded-lg hover:bg-gray-800 transition shadow-sm active:scale-95"
    >
      <Download size={18} /> 
      <span className="font-bold">PDF</span>
    </button>
  </div>
</div>

      {/* DUAL COLUMN BALANCE SHEET */}
      <div className="grid grid-cols-1 md:grid-cols-2 border-2 border-black rounded-2xl overflow-hidden shadow-2xl bg-white">
        
        {/* DEBIT / ASSETS */}
        <div className="p-8 border-r-2 border-black">
          <h2 className="text-xs font-black text-blue-600 uppercase tracking-widest mb-8 border-b-2 border-blue-50 pb-2">Debit - Assets</h2>
          <div className="space-y-6">
            <BalanceRow label="Total Principal Investment" value={data.totalInvestment} />
            <BalanceRow label="Current Weekly Target (Active)" value={data.weeklyInterestPotential} />
            
            <div className="mt-32 pt-6 border-t-4 border-double border-black">
              <div className="flex justify-between items-center">
                <span className="text-xl font-black uppercase tracking-tighter">Total Assets</span>
                {/* <span className="text-2xl font-black text-blue-800">
                  ₹{Number(data.totalInvestment).toLocaleString()}
                </span> */}
                <span className="text-2xl font-black text-blue-800">
  ₹{Number(
    data.totalInvestment + data.weeklyInterestPotential
  ).toLocaleString()}
</span>

              </div>
            </div>
          </div>
        </div>

        {/* CREDIT / EQUITY */}
        <div className="bg-gray-50 p-8">
          <h2 className="text-xs font-black text-green-600 uppercase tracking-widest mb-8 border-b-2 border-green-100 pb-2">Credit - Equity</h2>
          <div className="space-y-6">
            <BalanceRow label="Interest Received (Actual Cash)" value={data.interestGenerated} green />
            <BalanceRow label="Total Operating Expenses" value={-data.totalExpenses} red />
            
            <div className="bg-white p-5 rounded-xl border-2 border-dashed border-green-300 mt-10">
               <BalanceRow label="Net Realized Profit" value={data.netProfit} bold green />
            </div>

            <div className="mt-20 pt-6 border-t-4 border-double border-black">
              <div className="flex justify-between items-center">
                <span className="text-xl font-black uppercase tracking-tighter">Total Equity</span>
                <span className="text-2xl font-black text-green-800">
                  ₹{data.netProfit.toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const BalanceRow = ({ label, value, bold, red, green }) => (
  <div className={`flex justify-between items-center ${bold ? "font-black" : "font-semibold"}`}>
    <span className="text-gray-500 text-sm uppercase tracking-tight">{label}</span>
    <span className={`text-base font-mono ${red ? "text-red-600" : green ? "text-green-600" : "text-gray-900"}`}>
      ₹{Number(value).toLocaleString(undefined, { minimumFractionDigits: 2 })}
    </span>
  </div>
);

export default BalanceSheet;